const RewardsRedeemed = {
  Cash: "cash",
};

export default RewardsRedeemed;
